import { useContext } from 'react';
import { ComboboxContext } from '../context';

export const useCombobox = () => {
  const context = useContext(ComboboxContext);

  if (!context) {
    throw new Error('useCombobox must be used within ComboboxProvider');
  }

  return context;
};
